const stripTags = (text = '') => text.replace(/<style([\S\s]*?)>([\S\s]*?)<\/style>|(<([^>]+)>)/gi, '').trim();
export default stripTags;
